import { slugify } from "@/lib/slugify";

const RAW_CITIES = [
  // Seine-Maritime
  { name: "Le Havre", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Rouen", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Dieppe", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Fécamp", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Yvetot", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Bolbec", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Lillebonne", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Montivilliers", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Harfleur", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Gonfreville-l'Orcher", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Sainte-Adresse", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Octeville-sur-Mer", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Étretat", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Barentin", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Elbeuf", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Sotteville-lès-Rouen", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Darnétal", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Grand-Quevilly", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Petit-Quevilly", department: "Seine-Maritime", region: "Haute-Normandie" },
  { name: "Saint-Étienne-du-Rouvray", department: "Seine-Maritime", region: "Haute-Normandie" },
  // Eure
  { name: "Évreux", department: "Eure", region: "Haute-Normandie" },
  { name: "Vernon", department: "Eure", region: "Haute-Normandie" },
  { name: "Louviers", department: "Eure", region: "Haute-Normandie" },
  { name: "Val-de-Reuil", department: "Eure", region: "Haute-Normandie" },
  { name: "Bernay", department: "Eure", region: "Haute-Normandie" },
  { name: "Pont-Audemer", department: "Eure", region: "Haute-Normandie" },
  { name: "Gisors", department: "Eure", region: "Haute-Normandie" },
  { name: "Les Andelys", department: "Eure", region: "Haute-Normandie" },
  // Calvados
  { name: "Caen", department: "Calvados", region: "Basse-Normandie" },
  { name: "Lisieux", department: "Calvados", region: "Basse-Normandie" },
  { name: "Bayeux", department: "Calvados", region: "Basse-Normandie" },
  { name: "Vire", department: "Calvados", region: "Basse-Normandie" },
  { name: "Deauville", department: "Calvados", region: "Basse-Normandie" },
  { name: "Trouville-sur-Mer", department: "Calvados", region: "Basse-Normandie" },
  { name: "Honfleur", department: "Calvados", region: "Basse-Normandie" },
  { name: "Hérouville-Saint-Clair", department: "Calvados", region: "Basse-Normandie" },
  { name: "Mondeville", department: "Calvados", region: "Basse-Normandie" },
  { name: "Ifs", department: "Calvados", region: "Basse-Normandie" },
  // Manche
  { name: "Cherbourg-en-Cotentin", department: "Manche", region: "Basse-Normandie" },
  { name: "Saint-Lô", department: "Manche", region: "Basse-Normandie" },
  { name: "Granville", department: "Manche", region: "Basse-Normandie" },
  { name: "Coutances", department: "Manche", region: "Basse-Normandie" },
  { name: "Avranches", department: "Manche", region: "Basse-Normandie" },
  { name: "Carentan-les-Marais", department: "Manche", region: "Basse-Normandie" },
  // Orne
  { name: "Alençon", department: "Orne", region: "Basse-Normandie" },
  { name: "Argentan", department: "Orne", region: "Basse-Normandie" },
  { name: "Flers", department: "Orne", region: "Basse-Normandie" },
  { name: "L'Aigle", department: "Orne", region: "Basse-Normandie" },
  { name: "Mortagne-au-Perche", department: "Orne", region: "Basse-Normandie" },
];

// Phase 1 : villes prioritaires, propres et qualitatives à publier/indexer dès le lancement.
// Toutes les autres villes existent dans l'architecture (routage fonctionnel) mais restent en noindex
// tant qu'elles n'ont pas un contenu jugé suffisamment unique et utile (voir README SEO dans PRD.md).
export const PHASE1_CITY_SLUGS = [
  "le-havre", "rouen", "caen", "dieppe", "evreux", "fecamp", "yvetot", "bolbec",
  "lillebonne", "montivilliers", "harfleur", "gonfreville-l-orcher", "sainte-adresse",
  "octeville-sur-mer", "honfleur", "deauville", "lisieux", "cherbourg-en-cotentin", "saint-lo", "alencon",
];

export const CITIES = RAW_CITIES.map((c) => ({
  ...c,
  slug: slugify(c.name),
  isPhase1: PHASE1_CITY_SLUGS.includes(slugify(c.name)),
}));

export const EXTERNAL_PLACES = {
  paris: { name: "Paris", isPhase1: true },
  rennes: { name: "Rennes", isPhase1: false },
  lille: { name: "Lille", isPhase1: false },
  bretagne: { name: "Bretagne", isPhase1: false },
  "ile-de-france": { name: "Île-de-France", isPhase1: false },
  "hauts-de-france": { name: "Hauts-de-France", isPhase1: false },
  normandie: { name: "Normandie", isPhase1: false },
};

export function getCityBySlug(slug) {
  return CITIES.find((c) => c.slug === slug);
}

export function resolvePlace(slug) {
  return getCityBySlug(slug) || (EXTERNAL_PLACES[slug] && { ...EXTERNAL_PLACES[slug], slug }) || null;
}

export function getNearbyCities(city, count = 4) {
  if (!city.department) return CITIES.filter((c) => c.isPhase1 && c.slug !== city.slug).slice(0, count);
  return CITIES.filter((c) => c.department === city.department && c.slug !== city.slug).slice(0, count);
}

export function getPhase1Cities() {
  return CITIES.filter((c) => c.isPhase1);
}
